import type { ReactNode } from 'react';
import styled from 'styled-components';

import { HeadlineXS } from '#src/atoms/typography/index.tsx';

type Props = {
  id: string;
  children: ReactNode;
  error?: boolean;
  required?: boolean;
};

const Label = styled(HeadlineXS)`
  color: var(--c-white);
  .error {
    font-weight: normal;
    color: var(--c-red-400);
  }
`;

export const FormLabel = ({ id, children, error, required = false }: Props) => {
  return (
    <Label as="label" htmlFor={id}>
      {children} {!!required && '*'}{' '}
      {!!error && <span className="error">{error || null}</span>}
    </Label>
  );
};
